import React from "react";
import { useGetAssignmentsMarkQuery } from "../../../features/assignmentMark/assignmentMarkApi";
import Error from "../../ui/Error";
import SingleAssignmentMark from "./SingleAssignmentMark";

export default function AssignmentMarkList() {
  const {
    data: assignmentsMark,
    isLoading,
    isError,
    error,
  } = useGetAssignmentsMarkQuery() || {};

  let content = null;

  if (isLoading) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        Loading...
      </div>
    );
  } else if (!isLoading && isError) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && assignmentsMark?.length === 0) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        No Videos Found!
      </div>
    );
  } else if (!isLoading && !isError && assignmentsMark?.length > 0) {
    content = assignmentsMark.map((assignment) => {
      return (
        <SingleAssignmentMark key={assignment.id} assignmentMark={assignment} />
      );
    });
  }

  return (
    <div className="overflow-x-auto mt-4">
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Assignment</th>
            <th className="table-th">Date</th>
            <th className="table-th">Student Name</th>
            <th className="table-th">Repo Link</th>
            <th className="table-th">Mark</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-600/50">{content}</tbody>
      </table>
    </div>
  );
}
